import { lazy } from 'react';

const ShopgateWidgetsProductListWidget = lazy(() => import('@shopgate/engage/page/widgets/ProductList'))

const ShopgateWidgetsCategoryListWidget = lazy(() => import('@shopgate/engage/page/widgets/CategoryList'))

const ShopgateWidgetsProductSliderWidget = lazy(() => import('@shopgate/engage/page/widgets/ProductSlider'))

const ShopgateWidgetsHtmlWidget = lazy(() => import('@shopgate/engage/page/widgets/HTML'))

const ShopgateWidgetsVideoWidget = lazy(() => import('@shopgate/engage/page/widgets/Video'))

const ShopgateWidgetsHeadlineWidget = lazy(() => import('@shopgate/engage/page/widgets/Headline'))

const ShopgateWidgetsImageWidget = lazy(() => import('@shopgate/engage/page/widgets/Image'))

const ShopgateWidgetsImageRowWidget = lazy(() => import('@shopgate/engage/page/widgets/ImageRow'))

const ShopgateWidgetsImageSliderWidget = lazy(() => import('@shopgate/engage/page/widgets/ImageSlider'))

const ShopgateWidgetsRichTextWidget = lazy(() => import('@shopgate/engage/page/widgets/RichText'))

const ShopgateWidgetsHeroBannerWidget = lazy(() => import('@shopgate/engage/page/widgets/HeroBanner'))

const ShopgateWidgetsButtonWidget = lazy(() => import('@shopgate/engage/page/widgets/Button'))

const ShopgateWidgetsNestedCategoryFilterWidget = lazy(() => import('@shopgate/engage/page/widgets/NestedCategoryFilter'))

const ShopgateWidgetsInternalPlaceholder = lazy(() => import('@shopgate/engage/page/widgets/Placeholder'))

export default {
  '@shopgate/widgets/productListWidget': ShopgateWidgetsProductListWidget,
  '@shopgate/widgets/categoryListWidget': ShopgateWidgetsCategoryListWidget,
  '@shopgate/widgets/productSliderWidget': ShopgateWidgetsProductSliderWidget,
  '@shopgate/widgets/htmlWidget': ShopgateWidgetsHtmlWidget,
  '@shopgate/widgets/videoWidget': ShopgateWidgetsVideoWidget,
  '@shopgate/widgets/headlineWidget': ShopgateWidgetsHeadlineWidget,
  '@shopgate/widgets/imageWidget': ShopgateWidgetsImageWidget,
  '@shopgate/widgets/imageRowWidget': ShopgateWidgetsImageRowWidget,
  '@shopgate/widgets/imageSliderWidget': ShopgateWidgetsImageSliderWidget,
  '@shopgate/widgets/richTextWidget': ShopgateWidgetsRichTextWidget,
  '@shopgate/widgets/heroBannerWidget': ShopgateWidgetsHeroBannerWidget,
  '@shopgate/widgets/buttonWidget': ShopgateWidgetsButtonWidget,
  '@shopgate/widgets/nestedCategoryFilterWidget': ShopgateWidgetsNestedCategoryFilterWidget,
  '@shopgate/widgetsInternal/Placeholder': ShopgateWidgetsInternalPlaceholder,
};
